import { render, staticRenderFns } from "./VariantsSelect.vue?vue&type=template&id=67f84d90&scoped=true&"
import script from "./VariantsSelect.vue?vue&type=script&lang=js&"
export * from "./VariantsSelect.vue?vue&type=script&lang=js&"
import style0 from "./VariantsSelect.vue?vue&type=style&index=0&id=67f84d90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f84d90",
  null
  
)

export default component.exports